/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import { remoteImageStaticUrl } from "common/utils/remote-image";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import "./RedrawInformation.scss";

export default function RedrawInformation({ isMobile = false, onClose, ...restProps }: any) {
  function beforeImageUrl() {
    return remoteImageStaticUrl("gen/redraw-info/before-v2.png", {
      ixlib: "rb-0.3.5",
      h: 275,
      dpr: 2,
      q: 60
    });
  }

  function afterImageUrl() {
    return remoteImageStaticUrl("gen/redraw-info/after-v2.png", {
      ixlib: "rb-0.3.5",
      h: 275,
      dpr: 2,
      q: 60
    });
  }

  function close() {
    onClose?.();
  }

  return (
    <div {...restProps} className={cn("redraw-information scope-549ee6b2", restProps.className)}>
      {isMobile ? (
        <div className="redraw-information__header scope-549ee6b2">
          <div className="redraw-information__header-title scope-549ee6b2">How it works</div>
          <div
            className="redraw-information__close-button scope-549ee6b2"
            onClick={close}
            data-testid="redraw-information-close-button"
          >
            <UseSvg
              className="redraw-information__close-button-icon scope-549ee6b2"
              icon="menu-close"
              data-testid="redraw-information-close-button-icon"
            />
          </div>
        </div>
      ) : null}
      <div className="redraw-information__item redraw-information__item--before scope-549ee6b2">
        <div className="redraw-information__item-header scope-549ee6b2">Original Upload</div>
        <img className="redraw-information__image scope-549ee6b2" src={beforeImageUrl()} />
        <div className="redraw-information__content scope-549ee6b2">
          <strong className="scope-549ee6b2">Sample message to designer:</strong>
          <br className="scope-549ee6b2" /> Please remove the pink background, change the ribbon
          color to blue, remove freckles. Change "It's a girl!" to Emma.{" "}
        </div>
      </div>
      <div className="redraw-information__arrow scope-549ee6b2">
        <UseSvg
          className="redraw-information__arrow-icon scope-549ee6b2"
          icon="arrow-right-long"
          data-testid="redraw-information-arrow-icon"
        />
      </div>
      <div className="redraw-information__item redraw-information__item--with-list scope-549ee6b2">
        <div className="redraw-information__item-header scope-549ee6b2">Designer Perfected</div>
        <img className="redraw-information__image scope-549ee6b2" src={afterImageUrl()} />
        <div className="redraw-information__content scope-549ee6b2">
          <div className="redraw-information__list scope-549ee6b2">
            <div className="redraw-information__list-item scope-549ee6b2">
              <span className="redraw-information__list-item-number scope-549ee6b2">1</span> Ribbon
              color changed{" "}
            </div>
            <div className="redraw-information__list-item scope-549ee6b2">
              <span className="redraw-information__list-item-number scope-549ee6b2">2</span>{" "}
              Freckles removed{" "}
            </div>
            <div className="redraw-information__list-item scope-549ee6b2">
              <span className="redraw-information__list-item-number scope-549ee6b2">3</span>{" "}
              Background removed{" "}
            </div>
            <div className="redraw-information__list-item scope-549ee6b2">
              <span className="redraw-information__list-item-number scope-549ee6b2">4</span> Text
              changed{" "}
            </div>
          </div>
        </div>
      </div>
      {!isMobile ? (
        <button
          className="redraw-information__close-button scope-549ee6b2"
          type="button"
          onClick={close}
          data-testid="redraw-information-close-button-1"
        >
          <UseSvg
            className="redraw-information__close-button-icon scope-549ee6b2"
            icon="menu-close"
            data-testid="redraw-information-close-button-icon-1"
          />
        </button>
      ) : null}
    </div>
  );
}
